module.exports = __webpack_public_path__ + "prod/1.42.2/img/header-img.066fc106.png";